import { action as apiAction } from 'api/Api'
import {
  setResponsible
} from 'routes/Board/redux/cards'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
  userId: number
}

const requestMakeUserResponsible = (payload: Payload) => async dispatch => {
  const { cardId, userId } = payload

  const optimisticAction = optimisticDispatch(dispatch, setResponsible({
    id: cardId,
    responsible: userId
  }))

  try {
    await apiAction('MakeUserResponsible', {
      cardId,
      userId
    })
  } finally {
    optimisticAction.revert()
  }
}

export default requestMakeUserResponsible
